import UtilisationEmailControls from '../../components/UtilisationEmailControls';
import React from 'react'
import { MenuItem, Stack, TextField } from '@mui/material';
import { useCorporateStore } from '../../services/corporates';
import { useAppContext } from '../../services/context/AppContext';
import { hasRole } from '../../utils/helper';
import Layout from '../../components/Layout'
import GridTable from '../../components/GridTable'
import { useEventStore } from '../../services/events';
import AddEventDialog from './AddEventDialog';
import { COLUMNS } from './constants';
import { MODULES } from '../../utils/constants';

const Events = () => {
    const { filters, setFilters, data, totalPages, currentPage, total, rows, isLoading, fetchGrid, onPageChange, onDelete } = useEventStore();

    const { allData: companies, fetchAll: fetchCompanies } = useCorporateStore();
    const { userData } = useAppContext();
    const isAdmin = hasRole(userData?.role, MODULES.ADMIN) || hasRole(userData?.backendRole, MODULES.ADMIN);
    React.useEffect(() => { if (isAdmin) void fetchCompanies(); }, [isAdmin, fetchCompanies]);
    const applyFilter = (key: string, value: string) => {
        const next = { ...filters };
        if (value) next[key] = value; else delete next[key];
        setFilters(next);
    };

    React.useEffect(() => {
        fetchGrid()
    }, [])

    return (
        <Layout appBarTitle="Events">
            <Layout.Header component={AddEventDialog} props={{ module: MODULES.EVENT }} />
            <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                {isAdmin && <TextField select size="small" label="Company" value={filters.corporateId || ''} onChange={event => applyFilter('corporateId', event.target.value)} sx={{ minWidth: 240 }}>
                    <MenuItem value="">All companies</MenuItem>
                    {companies.map(company => <MenuItem key={company._id} value={company._id}>{company.companyName}</MenuItem>)}
                </TextField>}
                <TextField select size="small" label="Event status" value={filters.isActive === undefined ? '' : String(filters.isActive)} onChange={event => applyFilter('isActive', event.target.value)} sx={{ minWidth: 160 }}>
                    <MenuItem value="">All events</MenuItem><MenuItem value="true">Active</MenuItem><MenuItem value="false">Inactive</MenuItem>
                </TextField>
            </Stack>
            <UtilisationEmailControls source="events" filters={filters} disabled={isLoading} />
            <Layout.Body
                component={GridTable}
                props={{
                    data,
                    columns: COLUMNS,
                    currentPage,
                    totalPages,
                    total,
                    loading: isLoading,
                    onPageChange,
                    module: MODULES.EVENT,
                    onDelete: (data: any) => onDelete(data._id),
                    rows
                }}
            />
        </Layout>
    )
}

export default Events
